<div class="col-xs-10 col-xs-offset-1 center-text">
	<h1>Unsubscribe from Spotidol</h1>
	<h2 *ngIf="err">{{ err }}</h2>
	<h2 *ngIf="unsubscribed">You have unsubscribed from Spotidol's e-mails!</h2>
</div>